const locale = {
	DETAILS_EXCH_MAIL_LOGS_IMPORT_DATE: 'Data import',
	DETAILS_EXCH_MAIL_LOGS_DIRECTION: 'Direzione',
	DETAILS_EXCH_MAIL_LOGS_SENDER: 'Mittente',
	DETAILS_EXCH_MAIL_LOGS_RECIPIENT: 'Destinatario',
	DETAILS_EXCH_MAIL_LOGS_SENT_DATE: 'Data invio',
	DETAILS_EXCH_MAIL_LOGS_SUBJECT: 'Oggetto',
	DETAILS_EXCH_MAIL_LOGS_ERROR: 'Errore',

	EXCH_MAIL_ERROR_UNKNOWN_MAIL: 'Indirizzo e-mail sconosciuto',
	EXCH_MAIL_ERROR_MAIL_NO_LINK: 'Indirizzo e-mail non collegato',
	EXCH_MAIL_ERROR_UNKNOWN_COMPANY: 'Azienda sconosciuta',
	EXCH_MAIL_ERROR_NO_FOLDERNAME: 'Nome cartella sconosciuto',
	EXCH_MAIL_ERROR_ALREADY_IMPORTED: 'Messaggio già importato',
	EXCH_MAIL_ERROR_DUPLICATE_FILE: 'Nome file duplicato'
};

export default locale;
